require('./manageRemindersController');

"use strict";

angular.module('app.myHockeyTv.manageReminders', [
    'app.myHockeyTv.manageReminders.manageRemindersController'
])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('app.myHockeyTv.manageReminders', {
                url: '/reminders?:event',
                templateUrl: 'components/myHockeyTv/manageReminders/manageRemindersView.html',
                controller: 'app.myHockeyTv.manageReminders.manageRemindersController',
                resolve: {
                    defaultOptions: [
                        '$stateParams',
                        function ($stateParams) {
                            return {
                                icalid_fk: parseInt($stateParams.event)
                            };
                        }
                    ]
                },
                subTitle: 'Manage Reminders',
                isChildState: true
            });
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/manageReminders/manageReminders.js